import React from 'react';
import UserListModule from '../modules/UserListModule.js';
import './Box.css';

const UserListBox = ({ user, isSmallScreen }) => {

    return (
        <div className={isSmallScreen ? "standard-box-screen-small" : "standard-box"}>

            <h4></h4>

            <UserListModule
                user={user}
                isSmallScreen={isSmallScreen}
            />
        </div>
    );
};

export default UserListBox;
